export default __webpack_public_path__ + "static/media/idea.b8fd890b.png";